import { CenterSpinner } from '@/components/ats';
import { OauthModal } from '@/components/ats/oauth';
import { useShowToast } from '@/hooks';
import { useMailBox } from '@/hooks/use-mailbox';
import { API_SERVICE } from '@/api/interviews';
import { useMarkAsReadMutation } from '@/store/query/notification';
import { KText } from '@/ui-library/components';
import { Button, Flex, useDisclosure } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';

export const ConfirmRSVPButtons = ({ interviewUrl, notification }) => {
  const interviewId = interviewUrl.split('/').pop();
  const markInterviewStatusMutation = useMutation({
    mutationFn: API_SERVICE.markInterviewStatus,
  });
  const toast = useShowToast();
  const [markAsRead] = useMarkAsReadMutation();
  const { isCalConnected } = useMailBox();
  const oauthActions = useDisclosure();

  const handleMarkInterviewStatus = async (status) => {
    if (!isCalConnected) {
      oauthActions.onOpen();
      return;
    }

    const res = await markInterviewStatusMutation.mutateAsync({
      interviewId,
      payload: { response_status: status },
    });
    if (res?.errors?.length) {
      toast({ status: 'error', title: 'Mark interview status failed' });
    } else {
      toast({ title: 'Interview status marked successfully' });
    }
    markAsRead({ id: notification?.id });
  };

  return (
    <Flex flexDir="column" gap="12px">
      <KText>Select one of the following options:</KText>
      {markInterviewStatusMutation.isPending ? (
        <CenterSpinner h="32px" spinnerProps={{ size: 'xs' }} />
      ) : (
        <Flex gap="6px">
          <Button
            variant="quaternary"
            flex="1"
            onClick={() => handleMarkInterviewStatus('accepted')}
          >
            Yes
          </Button>
          <Button
            variant="quaternary"
            flex="1"
            onClick={() => handleMarkInterviewStatus('declined')}
          >
            No
          </Button>
          <Button
            variant="quaternary"
            flex="1"
            onClick={() => handleMarkInterviewStatus('tentative')}
          >
            Maybe
          </Button>
        </Flex>
      )}
      {oauthActions.isOpen && (
        <OauthModal
          isOpen={oauthActions.isOpen}
          onClose={oauthActions.onClose}
        />
      )}
    </Flex>
  );
};
